export default function initLinkModals() {
    const focusableElements = 'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])';
    const links = document.querySelectorAll(".wilo-link-modal-trigger");
    console.log('initialize modals');

    links.forEach(link => {
        const modalContent = link.getAttribute("data-modal-content");
        const labelClose = link.getAttribute("data-label-close") || "Close modal";
        if (!modalContent) return;

        const modalHTML = `
            <div class="wilo-link-modal" role="dialog" aria-hidden="true">
                <div class="wilo-link-modal-overlay"></div>
                <div class="wilo-link-modal-content">
                    <div class="wilo-link-modal-header">
                        <button class="wilo-link-modal-close-button" aria-label="${labelClose}">
                            <img src="data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjNTA1MDUwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMjAgNTEyIj48cGF0aCBkPSJNMTkzLjk0IDI1NkwyOTYuNSAxNTMuNDRsMjEuMTUtMjEuMTVjMy4xMi0zLjEyIDMuMTItOC4xOSAwLTExLjMxbC0yMi42My0yMi42M2MtMy4xMi0zLjEyLTguMTktMy4xMi0xMS4zMSAwTDE2MCAyMjIuMDYgMzYuMjkgOTguMzRjLTMuMTItMy4xMi04LjE5LTMuMTItMTEuMzEgMEwyLjM0IDEyMC45N2MtMy4xMiAzLjEyLTMuMTIgOC4xOSAwIDExLjMxTDEyNi4wNiAyNTYgMi4zNCAzNzkuNzFjLTMuMTIgMy4xMi0zLjEyIDguMTkgMCAxMS4zMWwyMi42MyAyMi42M2MzLjEyIDMuMTIgOC4xOSAzLjEyIDExLjMxIDBMMTYwIDI4OS45NCAyNjIuNTYgMzkyLjVsMjEuMTUgMjEuMTVjMy4xMiAzLjEyIDguMTkgMy4xMiAxMS4zMSAwbDIyLjYzLTIyLjYzYzMuMTItMy4xMiAzLjEyLTguMTkgMC0xMS4zMUwxOTMuOTQgMjU2eiIvPjwvc3ZnPg0K" height="25" width="25">
                        </button>
                    </div>
                    <div class="wilo-link-modal-body">
                        ${modalContent}
                    </div>
                </div>
            </div>
        `;

        const modalContainer = document.createElement("div");
        modalContainer.innerHTML = modalHTML.trim();
        const modal = modalContainer.firstChild;
        document.body.appendChild(modal);

        const overlay = modal.querySelector(".wilo-link-modal-overlay");
        const closeButton = modal.querySelector(".wilo-link-modal-close-button");
        let firstFocusableElement, lastFocusableElement;

        function openModal() {
            modal.classList.add("active");
            modal.setAttribute("aria-hidden", "false");
            document.querySelector(".page-wrapper")?.setAttribute("aria-hidden", "true");
            const focusableContent = modal.querySelectorAll(focusableElements);
            firstFocusableElement = focusableContent[0];
            lastFocusableElement = focusableContent[focusableContent.length - 1];
            firstFocusableElement.focus();
        }

        function closeModal() {
            modal.classList.remove("active");
            modal.setAttribute("aria-hidden", "true");
            document.querySelector(".page-wrapper")?.setAttribute("aria-hidden", "false");
            link.focus(); // Return focus to the trigger element
        }

        link.addEventListener("click", function (event) {
            event.preventDefault();
            openModal();
        });

        overlay.addEventListener("click", closeModal);
        closeButton.addEventListener("click", closeModal);

        document.addEventListener("keydown", function (event) {
            if (modal.classList.contains("active")) {
                if (event.key === "Escape") {
                    closeModal();
                }
                if (event.key === "Tab") {
                    if (event.shiftKey) {
                        if (document.activeElement === firstFocusableElement) {
                            event.preventDefault();
                            lastFocusableElement.focus();
                        }
                    } else {
                        if (document.activeElement === lastFocusableElement) {
                            event.preventDefault();
                            firstFocusableElement.focus();
                        }
                    }
                }
            }
        });
    });
}
